var _circle, _rect, _rect2, _path, _path2, _path3, _path4, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArchiveJournalIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 35,
    viewBox: "0 0 35 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 17.5,
    cy: 17.5,
    r: 17.5,
    fill: "url(#paint0_linear_9780_39859)"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 35,
    height: 35,
    rx: 17.5,
    fill: "#5E639B"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 35,
    height: 35,
    rx: 17.5,
    fill: "url(#paint1_linear_9780_39859)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.0633 15.8073C18.0633 15.1653 19.5066 13.0574 20.4385 13.0574H23.6876V9.58875C23.6876 9.27857 23.4363 9.02686 23.1251 9.02686H12.8765C11.5359 9.02686 9.93945 9.64487 9.93945 12.5886V21.3387C9.93945 21.9706 10.013 22.495 10.1413 22.9289C10.1509 22.999 10.1728 23.0647 10.2052 23.1247C10.7143 24.5512 11.8684 24.9005 12.8765 24.9005H23.1251C23.3567 24.9005 23.563 24.7575 23.6477 24.5416C23.7324 24.3257 23.6747 24.0795 23.5042 23.9227C23.4979 23.917 22.9266 23.3815 22.917 22.698C22.9114 22.2904 23.1134 21.885 23.517 21.4925C23.5182 21.4919 23.5192 21.4913 23.5182 21.4913C23.5182 21.4907 23.5194 21.4901 23.5194 21.4901C23.5194 21.4901 23.52 21.4901 23.5205 21.4896L23.5211 21.489L23.5217 21.4878C23.5323 21.4772 23.5424 21.4671 23.5514 21.4559C23.552 21.4553 23.552 21.4553 23.552 21.4547C23.5526 21.4547 23.5526 21.4542 23.5532 21.4536C23.6322 21.3617 23.6817 21.2439 23.6872 21.1148C23.6872 21.1043 23.6878 21.0947 23.6878 21.0839V18.5571H20.4387C19.5066 18.5575 18.0633 16.4497 18.0633 15.8076L18.0633 15.8073ZM22.0452 23.7749H12.8765C12.0422 23.7749 11.5218 23.4604 11.2627 22.7595C11.2873 21.9033 11.6782 21.6498 13.8444 21.6498H22.0247C21.8626 21.9946 21.7854 22.3541 21.7926 22.7253C21.8004 23.1211 21.9064 23.4767 22.0455 23.7749H22.0452Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.0633 15.8073C18.0633 15.1653 19.5066 13.0574 20.4385 13.0574H23.6876V9.58875C23.6876 9.27857 23.4363 9.02686 23.1251 9.02686H12.8765C11.5359 9.02686 9.93945 9.64487 9.93945 12.5886V21.3387C9.93945 21.9706 10.013 22.495 10.1413 22.9289C10.1509 22.999 10.1728 23.0647 10.2052 23.1247C10.7143 24.5512 11.8684 24.9005 12.8765 24.9005H23.1251C23.3567 24.9005 23.563 24.7575 23.6477 24.5416C23.7324 24.3257 23.6747 24.0795 23.5042 23.9227C23.4979 23.917 22.9266 23.3815 22.917 22.698C22.9114 22.2904 23.1134 21.885 23.517 21.4925C23.5182 21.4919 23.5192 21.4913 23.5182 21.4913C23.5182 21.4907 23.5194 21.4901 23.5194 21.4901C23.5194 21.4901 23.52 21.4901 23.5205 21.4896L23.5211 21.489L23.5217 21.4878C23.5323 21.4772 23.5424 21.4671 23.5514 21.4559C23.552 21.4553 23.552 21.4553 23.552 21.4547C23.5526 21.4547 23.5526 21.4542 23.5532 21.4536C23.6322 21.3617 23.6817 21.2439 23.6872 21.1148C23.6872 21.1043 23.6878 21.0947 23.6878 21.0839V18.5571H20.4387C19.5066 18.5575 18.0633 16.4497 18.0633 15.8076L18.0633 15.8073ZM22.0452 23.7749H12.8765C12.0422 23.7749 11.5218 23.4604 11.2627 22.7595C11.2873 21.9033 11.6782 21.6498 13.8444 21.6498H22.0247C21.8626 21.9946 21.7854 22.3541 21.7926 22.7253C21.8004 23.1211 21.9064 23.4767 22.0455 23.7749H22.0452Z",
    fill: "url(#paint2_linear_9780_39859)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M24.3116 13.806H20.4375C20.0231 13.806 18.8125 15.4619 18.8125 15.8056C18.8125 16.1494 20.0231 17.8051 20.4375 17.8051H24.3116C24.7254 17.8051 25.0612 17.4687 25.0612 17.0549V14.5565C25.0612 14.1427 24.726 13.8061 24.3116 13.8061V13.806ZM21.343 16.7433C20.8249 16.7433 20.4054 16.3238 20.4054 15.8057C20.4054 15.2876 20.8249 14.8681 21.343 14.8681C21.8611 14.8681 22.2806 15.2876 22.2806 15.8057C22.2806 16.3238 21.8611 16.7433 21.343 16.7433Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M24.3116 13.806H20.4375C20.0231 13.806 18.8125 15.4619 18.8125 15.8056C18.8125 16.1494 20.0231 17.8051 20.4375 17.8051H24.3116C24.7254 17.8051 25.0612 17.4687 25.0612 17.0549V14.5565C25.0612 14.1427 24.726 13.8061 24.3116 13.8061V13.806ZM21.343 16.7433C20.8249 16.7433 20.4054 16.3238 20.4054 15.8057C20.4054 15.2876 20.8249 14.8681 21.343 14.8681C21.8611 14.8681 22.2806 15.2876 22.2806 15.8057C22.2806 16.3238 21.8611 16.7433 21.343 16.7433Z",
    fill: "url(#paint3_linear_9780_39859)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_9780_39859",
    x1: 3.88889,
    y1: 29.8148,
    x2: 35,
    y2: 11.8827,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF939C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FEC7CC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_9780_39859",
    x1: 31.3272,
    y1: 7.07646,
    x2: 4.53704,
    y2: 32.3542,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F3D6F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E0B2E8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_9780_39859",
    x1: 11.1179,
    y1: 23.7113,
    x2: 27.9015,
    y2: 12.0773,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AC75B5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CA94D2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_9780_39859",
    x1: 19.3481,
    y1: 17.5055,
    x2: 23.753,
    y2: 11.997,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AC75B5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CA94D2"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArchiveJournalIcon);
export default __webpack_public_path__ + "static/media/ArchiveJournalIcon.464665eb48eda55dc751a5ff58e99cb3.svg";
export { ForwardRef as ReactComponent };